import { FC, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { ResponsiveImage } from "../../../components/ResponsiveImage";
import { Mail, Phone } from "../../../components/Icons/Generic";
import { BlogCard } from "../../../components/BlogCard";
import { OrangePlayFull } from "components/Icons/OrangePlayFull";
import { useIsMobile } from "../../../utils/hooks/useWindowSize";
import { HeaderSEO } from "components/headerSEO";
import { ISeo } from "interfaces/interfaces";
import { Review } from "../../../landing-components/Review";
import reviewer from "assets/images/GreteVisser.webp";

import { FlexSection, HighlightedSection } from "components/containers";
import { Title, ConceptCard, ReviewSection, DataGrid, Content } from "./styles";

const Partners: FC = () => {
  const { t } = useTranslation("partners");
  const isMobile = useIsMobile();

  const [textWidth, setTextWidth] = useState<string>("275px");

  useEffect(() => {
    if (isMobile) {
      setTextWidth("175px");
    } else {
      setTextWidth("275px");
    }
  }, [isMobile]);
  const seo = t("seo", { returnObjects: true }) as ISeo;

  return (
    <Content>
      {seo && <HeaderSEO {...seo} />}
      <Title>{t("partners.title")}</Title>
      <OrangePlayFull
        viewView={textWidth}
        viewHeight="12px"
        marginBottom="0.3em"
        strokeWidth="8"
      />
      <FlexSection grow={40}>
        <ResponsiveImage
          imgSrc={
            "rootpage/partners/Joost Bokkers geeft presentatie over kamertekort en Hospi Housing"
          }
          mobileSize={"95vw"}
          tabletSize={"40vw"}
          desktopSize={"50vw"}
          aspectRatio={"4/3"}
          minWidth={"22rem"}
        />
        <div>
          <h3>{t("partners.philosophy.header")}</h3>
          <h2>{t("partners.philosophy.title")}</h2>
          <p>{t("partners.philosophy.description")}</p>
        </div>
      </FlexSection>
      <section>
        <h3>{t("partners.concept.header")}</h3>
        <h2>{t("partners.concept.title")}</h2>
        <FlexSection grow={20}>
          <ConceptCard>
            <div>1</div>
            {t("partners.concept.1.title")}
            <p>{t("partners.concept.1.description")}</p>
          </ConceptCard>
          <ConceptCard>
            <div>2</div>
            {t("partners.concept.2.title")}
            <p>{t("partners.concept.2.description")}</p>
          </ConceptCard>
          <ConceptCard>
            <div>3</div>
            {t("partners.concept.3.title")}
            <p>{t("partners.concept.3.description")}</p>
          </ConceptCard>
        </FlexSection>
      </section>
      <FlexSection grow={40} reverse>
        <ResponsiveImage
          imgSrc={"team/joost"}
          mobileSize={"95vw"}
          tabletSize={"40vw"}
          desktopSize={"50vw"}
          aspectRatio={"4/3"}
          minWidth={"22rem"}
          loadingType="lazy"
        />
        <div>
          <h3>{t("partners.collaboration.header")}</h3>
          <h2>{t("partners.collaboration.title")}</h2>
          <p>{t("partners.collaboration.description")}</p>
          <HighlightedSection>{Mail}joost@hospihousing.com</HighlightedSection>
          <HighlightedSection>{Phone}06 13388424</HighlightedSection>
        </div>
      </FlexSection>
      <FlexSection grow={40}>
        <DataGrid>
          <div>
            <h2>50.000+</h2>
            <p>{t("partners.data.1")}</p>
          </div>
          <div>
            <h2>185+</h2>
            <p>{t("partners.data.2")}</p>
          </div>
          <div>
            <h2>3500+</h2>
            <p>{t("partners.data.3")}</p>
          </div>
          <div>
            <h2>4,7 / 5</h2>
            <p>{t("partners.data.4")}</p>
          </div>
        </DataGrid>
        <div>
          <h3>{t("partners.data.header")}</h3>
          <h2>{t("partners.data.title")}</h2>
          <p>{t("partners.data.description")}</p>
        </div>
      </FlexSection>
      <ReviewSection>
        <Review
          reviewText={t("partners.quote.text")}
          authorName={t("partners.quote.authorName")}
          authorInfo={t("partners.quote.authorInfo")}
          src={reviewer}
        />
      </ReviewSection>
      <section>
        <h3>{t("partners.proud.header")}</h3>
        <h2>{t("partners.proud.title")}</h2>
        <FlexSection grow={30} notCentering>
          <BlogCard
            post_id={"gemeente-maastricht-start-samenwerking-hospi-housing"}
            short_desc={true}
          />
          <BlogCard
            post_id={"gemeente-groningen-start-samenwerking-hospi-housing"}
            short_desc={true}
          />
          <BlogCard
            post_id={"kamer-verhuren-in-een-sociale-huurwoning"}
            short_desc={true}
          />
        </FlexSection>
      </section>
    </Content>
  );
};

export default Partners;
